export function Timezone(obj) {
    this.abbreviation = obj.abbreviation;
    this.continent = obj.continent;
    this.label = obj.label;
    this.city = obj.city;
    this.isLocation = obj.isLocation;
    this.locationCode = obj.locationCode;
}
